import React, { ReactElement } from 'react'
import { IconButton as MuiIconButton, Tooltip } from '@mui/material'
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton'

export type IconButtonProps = MuiIconButtonProps & {
	tooltipTitle?: string
	children: ReactElement
}

const IconButton = ({
	tooltipTitle,
	children,
	...iconButtonProps
}: IconButtonProps) => (
	<MuiIconButton
		{...iconButtonProps}
		aria-label={tooltipTitle || iconButtonProps['aria-label']}
	>
		{tooltipTitle ? (
			<Tooltip title={tooltipTitle}>{children}</Tooltip>
		) : (
			children
		)}
	</MuiIconButton>
)

export default IconButton
